import { createReducer } from "@ngrx/store";
import { initialPagesStore } from "./pages.state";

// Page reducers (array format)
import { quoteReducer } from "./quote/quote.reducer";
import { quoteCreateReducer } from "./quote-create/quote/quote-create.reducer";
import { quoteSubscriptionCreateReducer } from "./quote-create/quote-subscription/quote-subscription-create.reducer";
import { customerReducer } from "./customer/customer.reducer";
import { contactReducer } from "./contact/contact.reducer";
import { contractReducer } from "./contract/contract.reducer";
import { catalogReducer } from "./catalog/catalog.reducer";
import { vendorReducer } from "./vendor/vendor.reducer";
import { salesOrderReducer } from "./sales-order/sales-order.reducer";
import { centralSupportReducer } from "./admin/central-support/central-support.reducer";
import { developerReducer } from "./admin/developer/developer.reducer";
import { superUserReducer } from "./admin/super-user/super-user.reducer";
import { contractAdminReducer } from "./admin/contract-admin/contract-admin.reducer";

// **************************************************************************
// PAGES REDUCER (consolidated)
// Combines all page-level reducers into a single feature store
// **************************************************************************

export const pagesReducer = createReducer(
    initialPagesStore,

    // **************************************************************************
    // QUOTE HANDLERS
    // **************************************************************************
    ...quoteReducer,

    // **************************************************************************
    // QUOTE CREATE HANDLERS
    // **************************************************************************
    ...quoteCreateReducer,

    // **************************************************************************
    // QUOTE SUBSCRIPTION CREATE HANDLERS
    // **************************************************************************
    ...quoteSubscriptionCreateReducer,

    // **************************************************************************
    // CUSTOMER HANDLERS
    // **************************************************************************
    ...customerReducer,

    // **************************************************************************
    // CONTACT HANDLERS
    // **************************************************************************
    ...contactReducer,

    // **************************************************************************
    // CONTRACT HANDLERS
    // **************************************************************************
    ...contractReducer,

    // **************************************************************************
    // CATALOG HANDLERS
    // **************************************************************************
    ...catalogReducer,

    // **************************************************************************
    // VENDOR HANDLERS
    // **************************************************************************
    ...vendorReducer,

    // **************************************************************************
    // SALES ORDER HANDLERS
    // **************************************************************************
    ...salesOrderReducer,

    // **************************************************************************
    // CENTRAL SUPPORT HANDLERS
    // **************************************************************************
    ...centralSupportReducer,

    // **************************************************************************
    // DEVELOPER HANDLERS
    // **************************************************************************
    ...developerReducer,

    // **************************************************************************
    // SUPER USER HANDLERS
    // **************************************************************************
    ...superUserReducer,

    // **************************************************************************
    // CONTRACT ADMIN HANDLERS
    // **************************************************************************
    ...contractAdminReducer,
);
